import React from 'react';

const ReportsShipper = () => {
    return (
        <div className="content">
            <div className="col-12">
                <div id="page-header" className="no-print">
                    <h1>
                        Залишки по моделях
                    </h1>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="">
                                        <td>Apple iPhone 8 Plus</td>
                                        <td>1</td>
                                        <td>$224.00</td>
                                        <td>$224</td>
                                    </tr>
                                    <tr className="">
                                        <td>Apple iPhone X</td>
                                        <td>1</td>
                                        <td>$191.00</td>
                                        <td>$191</td>
                                    </tr>
                                    <tr className="">
                                        <td>Apple iPhone XR</td>
                                        <td>2</td>
                                        <td>$471.00</td>
                                        <td>$236</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>
                                <a href="/reports?type=shipper&amp;by=colors&amp;devices=iphones">iPhone - Ready (4)</a>
                            </h4>
                        </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>

                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>
                                <a href="/reports?type=shipper&amp;by=colors&amp;devices=iphones_service">iPhone - Service (0)</a>
                            </h4>
                        </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="">
                                        <td>Apple iPhone 7</td>
                                        <td>1</td>
                                        <td>$77.00</td>
                                        <td>$77</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>
                                <a href="/reports?type=shipper&amp;by=colors&amp;devices=iphones_icloud">iPhone - iCloud (1)</a>
                            </h4>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="">
                                        <td>Samsung Galaxy Tab A8</td>
                                        <td>2</td>
                                        <td>$180.00</td>
                                        <td>$90</td>
                                    </tr>
                                    <tr className="">
                                        <td>Apple iPad (3rd generation)</td>
                                        <td>1</td>
                                        <td>$27.00</td>
                                        <td>$27</td>
                                    </tr>
                                    <tr className="">
                                        <td>Apple iPad 3</td>
                                        <td>1</td>
                                        <td>$27.00</td>
                                        <td>$27</td>
                                    </tr>
                                    <tr className="">
                                        <td>Apple iPad Air 2</td>
                                        <td>3</td>
                                        <td>$294.50</td>
                                        <td>$98</td>
                                    </tr>
                                    <tr className="">
                                        <td>Apple iPad mini 3</td>
                                        <td>1</td>
                                        <td>$64.00</td>
                                        <td>$64</td>
                                    </tr>
                                    <tr className="">
                                        <td>Samsung SM-T357</td>
                                        <td>1</td>
                                        <td>$90.00</td>
                                        <td>$90</td>
                                    </tr>
                                    <tr className="">
                                        <td>Samsung Tab S2 SM-T719</td>
                                        <td>30</td>
                                        <td>$2490.00</td>
                                        <td>$83</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>
                                <a href="/reports?type=shipper&amp;by=colors&amp;devices=tablets">Tablets - Ready (39)</a>
                            </h4>
                        </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>

                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>
                                <a href="/reports?type=shipper&amp;by=colors&amp;devices=tablets_service">Tablets - Service (0)</a>
                            </h4>
                        </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>
                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>
                                <a href="/reports?type=shipper&amp;by=colors&amp;devices=tablets_icloud">Tablets - iCloud (0)</a>
                            </h4>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="">
                                        <td>Samsung Galaxy S9+</td>
                                        <td>1</td>
                                        <td>$124.00</td>
                                        <td>$124</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>Phones - Ready (1)</h4>
                        </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>

                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>Phones - Service (0)</h4>
                        </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <div className="sipper_found_products">
                            <table className="table table-sm table-striped" style={{ order: "2" }}>
                                <thead className="no-print">
                                    <tr>
                                        <th data-field="user_status">Модель</th>
                                        <th data-field="user_status">Кількість</th>
                                        <th data-field="user_status">Закупка</th>
                                        <th data-field="user_status">Середня</th>

                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                            <h4 style={{ order: "1" }}>Phones - iCloud (0)</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportsShipper;